define('modules/htmlad/templates/htmlad_templates_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  'URIjs/URI',
  './htmlad_templates_collection',
  './collection/htmlad_templates_collection_item_view',

  'modules/util/collection/collection_view',
  'modules/filter/filter_view',
  'modules/loading/loading_spinner_view',

  'text!./htmlad_templates_template.html',
], function (
  Backbone,
  $,
  _,
  session,
  URI,
  htmlAdTemplatesCollection,
  HtmlAdTemplateGridItemView,
  CollectionView,
  FilterView,
  Loading,
  htmlad_templates_template
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.collection = false;
      this.subViews = [];

      this.render();

      var loading = new Loading();
      this.subViews.push(loading);

      this.collection = htmlAdTemplatesCollection;

      this.listenTo(this.collection, 'request', loading.start.bind(loading));

      this.listenTo(
        this.collection,
        'sync',
        function (collection) {
          loading.done();
          this.renderList();
          $(window).scrollTop(
            sessionStorage.getItem(
              'scrollTopPosition_' + document.location.pathname
            )
          );
        },
        this
      );

      this.listenTo(this.collection, 'sync', function () {
        loading.done();
      });

      this.collection.params = _.extend(
        this.collection.params,
        URI.parseQuery(this.params)
      );
      if (this.zone_id) {
        this.collection.params = _.extend(this.collection.params, {
          zone_id: this.zone_id,
        });
      }
      if (this.player_id) {
        this.collection.params = _.extend(this.collection.params, {
          player_id: this.player_id,
        });
      }

      this.collection.params = _.extend(this.collection.params, {
        filter_id: 0,
      });

      this.collection.fetch();
    },

    hasSidebar: false,
    subViews: [],

    template: _.template(htmlad_templates_template),

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    renderList: function () {
      var items = [],
        htmlAdTemplateList,
        filterView;

      // var currentRoute = Backbone.history.getFragment();
      // var currentRouteHasZoneId = currentRoute.includes('?zone_id=');

      // console.log('formview - currentRoute - has zone id', currentRouteHasZoneId);

      filterView = new FilterView({
        filter_id: this.collection.params.filter_id,
        moduleApi: 'htmltemplates',
        // hasStaticZone: currentRouteHasZoneId
      });

      htmlAdTemplateList = new CollectionView({
        viewType: CollectionView.GRID,
        items: this.collection,
        itemView: HtmlAdTemplateGridItemView,
        extraParams: {
          zone_id: this.zone_id || '',
          player_id: this.player_id || '',
        },
        options: {
          filter: filterView.$el,
        },
      });

      filterView.model.fetch();

      this.listenTo(
        filterView.filterModel,
        'sync',
        function (model) {
          var currentRoute = Backbone.history.getFragment();
          var currentRouteHasZoneId = currentRoute.includes('?zone_id=');

          if (!currentRouteHasZoneId) {
            this.collection.params.zone_id = 0;
          }

          this.collection.fetch();
        },
        this
      );

      this.$('.js-htmlad-templates-list').html(htmlAdTemplateList.$el);

      this.subViews.push(htmlAdTemplateList, filterView);

      return this;
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

